import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppStateFacade } from '@app-state';

import * as FileSaver from 'file-saver';
import { catchError } from 'rxjs/operators';

import { WindowFunctions } from './window.functions';

const FOLDER_QUERY_PARAM = 'organizationUnitId';

@Injectable()
export class FileDownloadService {
    constructor(
        private _http: HttpClient,
        private _appState: AppStateFacade,
    ) { }

    public download(url: string) {
        return this._http.head(url)
            .pipe(
                // retrieve the error message from the server:
                // since HEAD doesn't return a body, we do a GET req
                catchError(() => this._http.get(url)),
            )
            .subscribe(
                () => WindowFunctions.windowHrefRedirect(url, {
                    [FOLDER_QUERY_PARAM]: `${this._appState.user.folder.value!.id}`,
                }),
            );
    }

    public downloadStringAsFile(filename: string, mimeType: string, content: string) {
        const blob = new Blob([content], { type: `${mimeType};charset=utf-8` });
        FileSaver.saveAs(blob, filename);
    }
}
